export default {
    title: 'Κυκλοφόρησε νέα έκδοση του athlisis',
    reload: 'Ανανέωση',
}
